import React, { useEffect, useRef } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import { useStore, walletActions } from '@modules';
import { FiatCurrencyEnum } from '@modules/global/types';
import { EditUserParams } from '@modules/user/types';

import Dropdown from '@components/Dropdown';

import SelectField from '../SelectField';

import style from './Currency.scss';

const cn = bemCssModules(style, 'Currency');
const ti = getTestId('Currency');

export type TCurrency = {
  onChangeValue(field: keyof EditUserParams, value: string | boolean): void;
};

export type DataType = { value: string; label: string }[];

export const Currency: CustomFC<TCurrency> = props => {
  const { className, onChangeValue } = props;

  const { t } = useTranslation();
  const [{ user, global }, dispatch] = useStore();
  const currencyRef = useRef<HTMLButtonElement>(null);
  const currency = user.data?.fiat_currency;
  const { config } = global.currencies;

  const onChange = (value: FiatCurrencyEnum) => {
    if (value !== currency) onChangeValue('fiat_currency', value);
  };

  useEffect(() => {
    dispatch(walletActions.getWallet());
  }, [currency]);

  if (!currency) return null;
  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      <SelectField ref={currencyRef} label={t('account.currency_select')}>
        {currency}
      </SelectField>

      <Dropdown
        className={cn('modal')}
        data={global.currencies.fiat}
        value={currency}
        customLabel={value => config.display_options[value]?.fullname}
        onChange={onChange}
        controller={currencyRef}
      />
    </div>
  );
};

export default Currency;
